// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1GXNP","approved":"Status_approved__3Psjh","rejected":"Status_rejected__3XlNf","expired":"Status_expired__1Nmof","label":"Status_label__1y-Do"};